import axios from 'axios';

// Ensure baseURL uses HTTPS
const getBaseURL = () => {
  let baseURL = process.env.REACT_APP_API_BASE_URL || '';

  // If baseURL is empty, return empty (will cause error, but better than wrong protocol)
  if (!baseURL) {
    console.warn('REACT_APP_API_BASE_URL is not set');
    return '';
  }

  // Remove any existing protocol
  baseURL = baseURL.replace(/^https?:\/\//, '');

  // Always prepend https://
  return `https://${baseURL}`;
};

const plainAxios = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
});

export default plainAxios;
